import { cn } from "@/lib/utils";

export const PrimaryButton = ({ className, ...props }) => (
  <button
    className={cn(
      "fa-btn group relative isolate inline-flex items-center justify-center gap-2 overflow-hidden rounded-full bg-fg px-6 py-3 text-[15px] font-medium text-canvas hover:bg-fg/85 disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  />
);

export const GhostButton = ({ className, ...props }) => (
  <button
    className={cn(
      "fa-btn inline-flex items-center justify-center gap-2 rounded-full border border-fg/15 bg-fg/[0.02] px-6 py-3 text-[15px] font-medium text-fg backdrop-blur-md hover:border-fg/40 hover:bg-fg/[0.06]",
      className
    )}
    {...props}
  />
);

export const Eyebrow = ({ className, children }) => (
  <p className={cn("font-mono text-[11px] uppercase tracking-[0.22em] text-tone", className)}>{children}</p>
);

export const Container = ({ className, children }) => (
  <div className={cn("mx-auto w-full max-w-6xl px-6 sm:px-10", className)}>{children}</div>
);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
};
